module.exports = __webpack_public_path__ + "static/social3.3982976c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/social3.jpg
// module id = 525
// module chunks = 77866191142387